import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7c597f04")

_pushScopeId("data-v-7c597f04")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("キャンセル")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_dialog, {
      fullscreen: "",
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel'))),
      title: _ctx.title,
      "custom-class": "select-dialog",
      modelValue: _ctx.modelValue,
      "onUpdate:modelValue": _ctx.modelValueChange
    }, _createSlots({
      footer: _withId(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel'))),
          size: "medium"
        }, {
          default: _withId(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 2
    }, [
      _renderList(_ctx.$slots, (index, name) => {
        return {
          name: name,
          fn: _withId(() => [
            _renderSlot(_ctx.$slots, name, {}, undefined, true)
          ])
        }
      })
    ]), 1032, ["title", "modelValue", "onUpdate:modelValue"])
  ]))
})